import styled from '@emotion/styled'
import {css, keyframes} from '@emotion/core'
import vars from './vars'

export const Container = styled('div')`
    position: relative;
    width: 100%;
    max-width: 960px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;

    @media (min-width: 400px) {
        width: 85%;
        padding: 0;
    }

    @media (min-width: 550px) {
        width: 80%;
    }
`

export const Page = styled('div')`
    padding: 4rem 0;
    overflow: hidden;

    @media (min-width: ${vars.bpLargerThanTablet}) {
        padding: 8rem 0;
        min-height: calc(100vh - 16rem);
    }
`

export const Intro = styled('div')`
    max-width: 56rem;
    font-size: 2rem;
    line-height: 1.4;
    margin-bottom: 3rem;

    h1 {
        font-size: 1.3em;
        margin-bottom: 0.2em;
    }

    @media (min-width: ${vars.bpLargerThanTablet}) {
        font-size: 3rem;
        line-height: 1.5;
    }

    strong {
        font-family: ${vars.headingsFontFamily};
        font-size: 1.1em;
    }
`

//

export const buttonLink = css`
    background: none;
    border: none;
    padding: 0;
    font-family: ${vars.bodyFontFamily};
    /* color: ${vars.linkColor}; */
    text-decoration: underline;
    cursor: pointer;
`

export const button = css`
    display: inline-block;
    height: 38px;
    padding: 0 30px;
    color: ${vars.white};
    text-align: center;
    font-size: 11px;
    font-weight: 600;
    line-height: 38px;
    letter-spacing: 0.1rem;
    text-transform: uppercase;
    text-decoration: none;
    white-space: nowrap;
    background-color: ${vars.black};
    border-radius: 4px;
    border: 1px solid ${vars.white};
    cursor: pointer;
    box-sizing: border-box;

    &:hover,
    &:focus {
        border-color: ${vars.linkColor};
        outline: 0;
        background-color: ${vars.linkColor};
    }
`

export const srOnly = css`
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;

    &:active,
    &:focus {
        position: static;
        width: auto;
        height: auto;
        margin: 0;
        overflow: visible;
        clip: auto;
    }
`

// FORMS

export const FormCombinedRow = styled('div')`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .form-group--three {
        width: 30%;
    }

    .form-group--two {
        width: 48%;
    }
`

export const FormGroup = styled('div')`
    position: relative;
    margin-bottom: 1rem;

    label {
        font-family: ${vars.headingsFontFamily};

        &.has-error {
            color: ${vars.red};
        }
    }

    input,
    textarea {
        font-family: ${vars.bodyFontFamily};
        font-size: 1.3rem;
    }

    textarea {
        resize: none;
    }
`

export const radio = css`
    display: flex;
    text-align: left;

    label {
        font-family: ${vars.bodyFontFamily};
        line-height: 1;
    }

    input[type='radio'] {
        border: 1px solid ${vars.black};

        &:checked,
        &:not(:checked) {
            position: absolute;
            left: -9999px;
        }

        &:checked + label,
        &:not(:checked) + label {
            position: relative;
            padding-left: 28px;
            cursor: pointer;
            line-height: 20px;
            display: inline-block;
            color: ${vars.black};

            &.has-error {
                color: ${vars.red};
            }
        }

        &:checked + label::before,
        &:not(:checked) + label::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 18px;
            height: 18px;
            border: 1px solid ${vars.black};
            border-radius: 100%;
            background: ${vars.white};
        }

        &:checked + label::after,
        &:not(:checked) + label::after {
            content: '';
            width: 12px;
            height: 12px;
            background: ${vars.black};
            position: absolute;
            top: 4px;
            left: 4px;
            border-radius: 100%;
            transition: all 0.2s ease;
        }

        &:not(:checked) + label::after {
            opacity: 0;
            transform: scale(0);
        }

        &:checked + label::after {
            opacity: 1;
            transform: scale(1);
        }
    }
`

export const formControl = css`
    margin-bottom: 2.5rem;
    width: 100%;
    border: none;
    border-bottom: 1px solid ${vars.black};
    border-radius: 0;
    background-image: linear-gradient(${vars.black}, ${vars.black});
    background-size: 0 2px;
    background-repeat: no-repeat;
    background-position: center bottom, center calc(100% - 1px);
    transition: background 0.3s ease-out;

    &:focus,
    &:active {
        border: none;
        background-size: 100% 2px;
    }

    &.has-error {
        border-bottom: 1px solid ${vars.red};
        background-image: linear-gradient(${vars.red}, ${vars.red});

        &:focus,
        &:active {
            border: none;
            background-size: 100% 2px;
        }
    }
`

export const checkbox = css`
    margin-bottom: 1.5rem;

    input[type='checkbox'] {
        opacity: 0;
        position: absolute;

        &:focus + label::before {
            outline: rgb(59, 153, 252) auto 5px;
        }

        & + label {
            display: inline-block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 20px;
            font-family: ${vars.bodyFontFamily};
            font-weight: 300;
            cursor: pointer;
        }

        & + label:last-child {
            margin-bottom: 0;
        }

        & + label::before {
            opacity: 1;
            content: '';
            display: block;
            width: 20px;
            height: 20px;
            border: 1px solid ${vars.black};
            position: absolute;
            left: 0;
            top: 0;
            transition: background-color 0.3s;

            &:focus {
                outline: inherit;
            }
        }

        &:checked + label::after {
            position: absolute;
            left: 5px;
            top: 5px;
            content: '';
            display: inline-block;
            height: 6px;
            width: 9px;
            border-left: 2px solid;
            border-bottom: 2px solid;
            border-color: ${vars.white};
            transform: rotate(-45deg);
            opacity: 1;
        }

        &:checked + label::before {
            background-color: ${vars.black};
        }
    }
`

const vibrate = keyframes`
    0% {
        transform: translate(0);
    }

    10% {
        transform: translate(-2px, -2px);
    }

    20% {
        transform: translate(2px, -2px);
    }

    30% {
        transform: translate(-2px, 2px);
    }

    40% {
        transform: translate(2px, 2px);
    }

    50% {
        transform: translate(-2px, -2px);
    }

    60% {
        transform: translate(2px, -2px);
    }

    70% {
        transform: translate(-2px, 2px);
    }

    80% {
        transform: translate(-2px, -2px);
    }

    90% {
        transform: translate(2px, -2px);
    }

    100% {
        transform: translate(0);
    }
`

export const Vibrate = styled('div')`
    animation: ${vibrate} 0.3s linear infinite both;
`
